// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { useEffect, useState } from "react"
import {
  IonButton,
  IonButtons,
  IonFooter,
  IonToolbar
} from "@ionic/react"
import { useLocales } from "react-localized"
import { NewPurchaseOrderProps, PlacePurchaseOrder } from "../components"
import { ScreenSizeConditional, SectionContainer } from "../lib"
import ProcurementSectionMenu from "./ProcurementSectionMenu"


const PurchaseOrderCreate: React.FC<NewPurchaseOrderProps> = ({
  onSubmit,
  order,
  ready,
}) => {
  const {gettext} = useLocales()
  const [canSubmit, setCanSubmit] = useState<boolean>(false)
  const cancelButton: React.ReactElement = (
    <IonButton
      color="medium"
      disabled={!canSubmit}
      fill="clear"
      //onClick={() => setSubmitted(true)}
      size="default"
    >
      {gettext("Cancel")}
    </IonButton>
  )
  const nextButton: React.ReactElement = (
    <IonButton
      color={(!!canSubmit) ? "primary" : "dark"}
      disabled={!canSubmit}
      fill="clear"
      onClick={() => onSubmit()}
      size="default"
    >
      {gettext("Next: select products")}
    </IonButton>
  )

  useEffect(() => {
    setCanSubmit(order.isValid())
  }, [order])

  return (
    <>
      <SectionContainer
        canGoBack={false}
        menuComponent={ProcurementSectionMenu}
        ready={ready}
        title={gettext("Create PO")}
      >
        <PlacePurchaseOrder cancelButton={cancelButton} nextButton={nextButton} order={order}/>
      </SectionContainer>
      <ScreenSizeConditional>
        <IonFooter>
          <IonToolbar>
            <IonButtons slot="start">{nextButton}</IonButtons>
            <IonButtons slot="end">{cancelButton}</IonButtons>
          </IonToolbar>
        </IonFooter>
      </ScreenSizeConditional>
    </>
  )
}

export default PurchaseOrderCreate